import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RoleDto } from 'projects/shared/src/lib/models/SquirrelRoles';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';

@Component({
  selector: 'delete-tenant-grouprole-dialog',
  templateUrl: './delete-tenant-grouprole-dialog.component.html',
  styleUrls: ['./delete-tenant-grouprole-dialog.component.css']
})
export class DeleteTenantGrouproleDialogComponent implements OnInit {

    groupRoleForm!: FormGroup;
    roleDto!: RoleDto;
    _db!:string;
    tenantName!: string;
    rowData!: any;
  
    constructor(private fb: FormBuilder,
      public dialogRef: MatDialogRef<DeleteTenantGrouproleDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private tenantService:TenantService,
      private oauthService: OAuthServiceService,
      public translate: TranslateService,
      private notificationService: NotificationService) { }
  
    ngOnInit(): void {
      // this.oauthService.userData.subscribe({
      //   next: (data) => {
      //     if (typeof data != undefined && data != null) {
      //       let userRoles = data.role as Array<string>;
      //       userRoles.forEach((dbrole: string) => {
      //         if (dbrole === 'admin') {
      //          this._db = dbrole;
      //         }
      //       });
      //     }
      //   }
      // });
      
      this.tenantName = this.data.tenantName;
      this.data = this.data.rowData;
      this.createGroupRoleForm();
    }
  
    createGroupRoleForm(){
      this.groupRoleForm = this.fb.group({
        groupRoleId:[this.data.id],
        // projectId:[this.data.projectId],
        name:[this.data.name]
      });
    }
  
    deleteGroupRole(id: string){
      if(this.groupRoleForm.valid){
        //let db:string = this.tenantService.currentTenantName;
        this.tenantService.deleteTenantGroupRole(this.tenantName, id).subscribe({
      //this.platformGroupRoleService.getPlatformPermissions().subscribe({
          next: () => {
            //this.refresh(this.params);
            this.dialogRef.close(this.groupRoleForm.value);
            this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["TENANTGROUPROLEDELETED"]} `);
            //this.dialog.open(TenantPermissionsComponent, {width: '500px', data:{tenantGroupRole: tenantGroupRole, tenantGroupRolePermissions: null}});
          },
          error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["TENANTGROUPROLEDELETEDERROR"]}`)
        });
      }
    }

    cancel() {
      this.dialogRef.close(this.groupRoleForm.value);
    }
  
  } 
